import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import api, { formatError } from "@/api/client";
import { BookOpen } from "lucide-react";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated!");
      navigate("/login");
    } catch (err) {
      setError(formatError(err));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-4">
      <div className="w-full max-w-md">
        <Link to="/login" className="flex items-center gap-2 mb-8">
          <div className="w-10 h-10 bg-[#41B5E6] flex items-center justify-center rounded-sm">
            <BookOpen className="w-5 h-5 text-white" />
          </div>
          <div className="font-black text-lg tracking-tight">Handle Docs</div>
        </Link>
        <div className="bg-white border border-zinc-200 p-8 rounded-sm">
          <h1 className="text-2xl font-bold mb-1">Set new password</h1>
          <p className="text-sm text-zinc-500 mb-6">Pick a strong password.</p>
          <form onSubmit={submit} className="space-y-4">
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="New password" data-testid="reset-password"
              className="w-full px-3 py-2.5 border border-zinc-300 rounded-sm text-sm focus:outline-none focus:ring-2 focus:ring-[#41B5E6]" />
            {error && <div className="text-sm text-rose-600">{error}</div>}
            <button data-testid="reset-submit" className="w-full bg-[#41B5E6] hover:bg-[#2A9BCC] text-white font-semibold py-2.5 rounded-sm">Update password</button>
          </form>
        </div>
      </div>
    </div>
  );
}
